export default __webpack_public_path__ + "static/collect-feedbacks-b12dfd6b1e4ae4972e8fd692b2acaee2.svg";